let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5eyT9")).then(() => parcelRequire('2Zp7K'));